<template>
    <tr v-on:click="gotoQuestion()">
        <th scope="row">{{ name }}</th>
        <td>
            <slot></slot>
        </td>
    </tr>
</template>

<style>
  tr {
    cursor: pointer;
  }
</style>

<script>
export default {
  name: "ConfirmRow",
  props: {
      name: String,
      goto: String
  },
  methods: {
    gotoQuestion: function() {
      this.$parent.$parent.$emit("setCurrentQuestion", this.goto);      
    },
  }
};
</script>